// Shared defaults for the Pruebas Informales vitrina.
export const DEFAULT_GRADE = /^1.*b[aá]sico/i;
export const DEFAULT_SUBJECT = /psicopedag/i;

export const SPECIAL_SUBJECTS = [
  "Psicología",
  "Fonoaudiología",
  "Psicopedagogía",
  // "Emocional sensorial y motriz",
  // "Habilidades adaptativas",
];

/** Pick the most representative material for a specialty (not the first in the list). */
export function pickDefaultMaterial(materials, subjectName) {
  const withPdf = (materials || []).filter((m) => m.pdf);
  if (!withPdf.length) return null;

  const subject = (subjectName || "").toLowerCase();
  let pattern = null;

  if (/psicopedag/i.test(subject)) {
    pattern = /psicopedag/i;
  } else if (/psicolog/i.test(subject)) {
    pattern = /psicol[oó]g/i;
  } else if (/fonoaudiolog/i.test(subject)) {
    pattern = /fonoaudiolog/i;
  } else if (/emocional|sensorial|motriz/i.test(subject)) {
    pattern = /emocional|sensorial|motriz/i;
  } else if (/habilidades adaptativas/i.test(subject)) {
    pattern = /habilidades adaptativas/i;
  }

  if (pattern) {
    const match = withPdf.find((m) => pattern.test(m.name));
    if (match) return match;
  }

  return withPdf[0];
}
